const coins = require('../coins');

module.exports = [{
    dataIndex: 0,
    id: '2pool',
    name: '2pool',
    lpTokenInfo: {
        name: '2Curve',
        symbol: '2Crv',
    },
    assets: 'DAI+USDC',
    coins: [
        coins.dai,
        coins.usdc,
    ],
    addresses: {
        swap: '0x27e611fd27b276acbd5ffd632e5eaebec9761e40',
        lpToken: '0x27e611fd27b276acbd5ffd632e5eaebec9761e40',
        gauge: '0xe49e0601b83590e0b323dc2fc87bb568d7cd5eb9',
    },
    hasNoGauge: true,
}];
